// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import NorthKorea from '../_raw/flag/icon_flag_north_korea.png';

export default () => <img src={NorthKorea} alt="NorthKorea" />;
